import {
  ConsultaSeguimentoPergunta17Model,
  ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-17/model-consultaSeguimentoPergunta17'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta17Model {
  header: MchatRfAplicacaoQueryModel
  perguntas: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta17Model
}

export const convertAplicacaoPergunta17 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta17Model | null => {
  const { header, perguntas } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_17_01)

  if (isUndefinedOrNull(header)) return null

  return {
    header,
    perguntas,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_17_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_17_TENTA_FAZER_QUE_OLHE: convertAplicacoesToExemplos(perguntas),
      OUTRO: convertAplicacaoToOutro(
        perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_17_06)
      ),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta17Model['OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum, undefined> = {
  [ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.FALA]: undefined,
  [ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.EMITE_SOM_OU_BARULHO]: undefined,
  [ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.OLHA_PARA]: undefined,
  [ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.CONTINUA_OLHANDO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_17_02]: ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.FALA,
  [MChatPerguntaEnum.PERGUNTA_17_03]: ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.EMITE_SOM_OU_BARULHO,
  [MChatPerguntaEnum.PERGUNTA_17_04]: ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.OLHA_PARA,
  [MChatPerguntaEnum.PERGUNTA_17_05]: ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum.CONTINUA_OLHANDO,
}
